import main from 'Theme/main'

export default {
  main,
}
